"use client";

import Heading from "@/components/heading";
import Image from "next/image";
import { useState } from "react";

export default function RestoreEnhance() {
  const data = [
    {
      title: "Structural and body repairs",
      icon: "Structural and body repairs.png",
      image: "Structural and body repairs image.png",
    },
    {
      title: "Camera and gimbal replacements",
      icon: "Camera and gimbal replacements.png",
      image: "Camera and gimbal replacements image.png",
    },
    {
      title: "Motor and propulsion system repair",
      icon: "Motor and propulsion system repair.png",
      image: "Motor and propulsion system repair image.png",
    },
    {
      title: "Firmware upgrades and recalibration",
      icon: "Firmware upgrades and recalibration.png",
      image: "Firmware upgrades and recalibration image.png",
    },
    {
      title: "Performance optimisation services",
      icon: "Performance optimisation services.png",
      image: "Performance optimisation services image.png",
    },
  ];
  const [selected, setSelected] = useState<(typeof data)[0]>(data[0]);

  return (
    <>
      <section
        style={{
          backgroundColor: "#fff",
          backgroundImage: 'url("/images/drone-repair/grill-bg.webp")',
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      >
        <div className="max-w-7xl mx-auto px-4 py-10 md:py-16">
          <div className="max-w-2xl mx-auto mb-6 md:mb-12">
            <Heading>Restore or Enhance Your Drone</Heading>
            <p className="text-center text-base md:text-xl">
              Whether your drone has suffered damage or you want to improve its
              performance, EVERSE provides:
            </p>
          </div>
          <div className="grid md:grid-cols-2 grid-cols-1 gap-x-6 lg:gap-x-12 gap-y-6 items-center">
            <div className="pr-0 lg:pr-6">
              <Image
                src={`/images/drone-repair/${selected.image}`}
                alt={selected.title}
                width={516}
                height={645}
                className="shrink-0"
              />
            </div>
            <div className="space-y-4">
              {data.map((v, i) => (
                <div
                  onMouseEnter={() => setSelected(v)}
                  key={i}
                  className="flex items-center gap-3 bg-white shadow-md hover:shadow-xl transition-shadow duration-300 p-4 rounded-2xl cursor-pointer"
                >
                  <Image
                    src={`/images/drone-repair/${v.icon}`}
                    alt={v.title}
                    width={56}
                    height={56}
                    className="shrink-0"
                  />
                  <p className="font-medium text-base md:text-lg lg:text-2xl">
                    {v.title}
                  </p>
                </div>
              ))}
            </div>
          </div>
          <p className="text-center mt-6 md:mt-12 text-base md:text-xl">
            Our goal is to extend your drone&apos;s life and reliability.
          </p>
        </div>
      </section>
    </>
  );
}
